import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { PcmpMisQueuePage } from '@/features/pcmp/pages/PcmpMisQueuePage';
import { pcmpMisQueueSearchSchema } from '@/features/pcmp/types/pcmpMis.types';

export const Route = createFileRoute('/_auth/pcmp/mis/')({
  validateSearch: pcmpMisQueueSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="PCMP MIS">
      <Suspense fallback={<PageLoader />}>
        <PcmpMisQueuePage />
      </Suspense>
    </ErrorBoundary>
  ),
});
